import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { COWTUXConfigService } from '@cowtux/services/config.service';
import { COWTUXNavigationService } from '@cowtux/components/navigation/navigation.service';
import { COWTUXSidebarService } from '@cowtux/components/sidebar/sidebar.service';

@Component({
    selector     : 'navbar-horizontal-style-1',
    templateUrl  : './style-1.component.html',
    styleUrls    : ['./style-1.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NavbarHorizontalStyle1Component implements OnInit, OnDestroy
{
    COWTUXConfig: any;
    navigation: any;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {COWTUXConfigService} _cowtuxConfigService
     * @param {COWTUXNavigationService} _cowtuxNavigationService
     * @param {COWTUXSidebarService} _cowtuxSidebarService
     */
    constructor(
        private _cowtuxConfigService: COWTUXConfigService,
        private _cowtuxNavigationService: COWTUXNavigationService,
        private _cowtuxSidebarService: COWTUXSidebarService
    )
    {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Get current navigation
        this._cowtuxNavigationService.onNavigationChanged
            .pipe(
                filter(value => value !== null),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                this.navigation = this._cowtuxNavigationService.getCurrentNavigation();
            });

        // Subscribe to the config changes
        this._cowtuxConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.COWTUXConfig = config;
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
